import { Text } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { updateWidget } from 'modules/Editor/store/infographSlice';
import { ToolbarNumberInput } from 'modules/common/components/Toolbar/ToolbarNumberInput';
import { useTranslation } from 'react-i18next';
import { LabelTextWidgetData } from 'widgets/TextBasedWidgets/LabelTextWidget/LabelTextWidget.types';
import { useEditor, useWidget } from 'widgets/sdk';

import { ComponentWidgetIdKeys, StatChartWidgetData } from '../StatChartWidget.types';

export const ChartValueInput = () => {
  const { componentWidgetIdMap } = useWidget<StatChartWidgetData>();
  const dispatch = useAppDispatch();
  const { boundingBox } = useEditor();
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'statChartToolbar.chartValue',
    useSuspense: false,
  });

  const label = t('label');

  const labelTextWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.MetricText];
  const labelTextWidgetValue = useAppSelector(
    (state) => (state.infograph.widgets[labelTextWidgetId] as LabelTextWidgetData).value,
  );
  const chartValue = parseFloat(labelTextWidgetValue);

  const updateChartValue = (newValue: number) => {
    const newValueAsString = `${newValue}`;
    if (labelTextWidgetValue === newValueAsString) return;

    dispatch(updateWidget({ widgetId: labelTextWidgetId, widgetData: { value: newValueAsString } }));

    // Update bounding box after state change
    setTimeout(() => boundingBox.updateRect(), 0);
  };

  return (
    <>
      <Text as='label' fontSize='sm' htmlFor=''>
        Value
      </Text>
      <ToolbarNumberInput value={chartValue} label={label} precision={2} suffix={'%'} onChange={updateChartValue} />
    </>
  );
};
